export const bodyStyles = { overflowY: 'auto' };

export const tableStyles = {
  tableLayout: 'fixed',
  height: '100%',
  borderCollapse: 'separate',
  borderSpacing: 0,

  '& .MuiTableCell-root': {
    height: 'auto',
    borderColor: ({ palette }) => palette.border.default,
  },
};
